import { useUser } from 'components/providers/UserProvider'
import { PricingSettings } from './PricingSettings'

export const PricingSettingsPresenter = (): JSX.Element => {
  const { user } = useUser()
  if (!user) return <></>

  return <PricingSettings />
}
